





















































import { Component, Prop } from 'vue-property-decorator';
import { DxSelectBox } from 'devextreme-vue';
import { StocksPageArgs, StocksMapItem } from './types';
import { Page } from '@/core/components/controls';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import StocksTable from './StocksTable.vue';
import { TableOptions, getTableCaption } from '@/core/components/table';
import { localize } from '../../core/filters';
import { CONTRACTS, WindowsServiceContract } from '@/core/contracts';

@Component({
    components: {
        StocksTable,
        TableOptions,
        DxSelectBox,
    },
})
export default class StocksPage extends Page {
    @Prop({ default: () => ({}) }) public args!: StocksPageArgs;
    @Inject(CONTRACTS.WindowsService)
    public _windowsService?: WindowsServiceContract;

    public canAccept: boolean = false;
    public canRefuse: boolean = false;
    public stockTable: any = null;
    public table: any = null;

    public isSelectDismissCommentVisible: boolean = false;
    public selectedCommentValue: string = this.getDefaultComment();
    public nextCommentAction: () => void = () => {};

    public async mounted() {
        this.setControlsVisibility();
        this.stockTable = this.getTable();
        this.table = this.stockTable.getDataGridInstance();
    }

    public get tableKey(): string {
        let key = 'stock-control';

        if (this.args.forConsumption) {
            key = 'consumption-' + key;
        }

        if (this.args.hasProject) {
            key = 'project-' + key;
        }

        if (this.args.unused) {
            key = 'unused-' + key;
        }

        if (this.args.freeStockProposalsSm) {
            key = 'freeStockProposalsSm-' + key;
        }

        if (this.args.minUsage) {
            key = 'minUsage-' + key;
        }

        if (this.args.freeStockCandidates) {
            key = 'freeStockCandidates-' + key;
        }

        return key;
    }

    public get tableName(): string {
        return getTableCaption(this.tableKey);
    }

    public get freeStockProposalComments() {
        const comments = localize('FreeStockProposalComments');
        return Array.isArray(comments) ? comments : [];
    }

    public getDefaultComment() {
        const comments = localize('FreeStockProposalComments');
        const arr = Array.isArray(comments) ? comments : [];
        return arr.length > 0 ? arr[0] : '';
    }

    public accept() {
        this.getTable().accept();
    }

    public refuse() {
        this.isSelectDismissCommentVisible = true;
        this.nextCommentAction = () => {
            this.getTable().refuse(this.selectedCommentValue);
            this.isSelectDismissCommentVisible = false;
        };
    }

    public showStocksMap() {
        const stocks = this.stockTable.filteredData;
        const stocksMapItems = this.getStocksMapPageItems(stocks);
        this._windowsService!.open('stocks-map-page', { stocksMapItems });
    }

    private getStocksMapPageItems(stocks: any[]): StocksMapItem[] {
        const weights = stocks.map(item => ({
            site: item.site,
            weight: item.quantityWeight,
        }));

        const sumBySite = new Map();
        weights.forEach(value => {
            sumBySite.set(
                value.site,
                sumBySite.get(value.site) + value.weight || value.weight
            );
        });

        const result: StocksMapItem[] = [];
        sumBySite.forEach((v, k) => {
            result.push({
                siteId: k.id,
                siteName: k.name,
                latitude: k.latitude,
                longitude: k.longitude,
                weight: v,
            });
        });

        return result;
    }

    private setControlsVisibility() {
        const isFreeStockProposalsSm = this.args.freeStockProposalsSm === true;
        this.canAccept = isFreeStockProposalsSm;
        this.canRefuse = isFreeStockProposalsSm;
    }

    private getTable(): StocksTable {
        const element = this.$refs['table-control'] as StocksTable;
        return element as StocksTable;
    }
}
